import { dateTimeFormat, relativeTimeFormat } from './intl'

/**
 * Tiempo relativo compacto para listas (campana, /notifications, raíl de chats):
 * "ahora" / "hace 5 min" / "hace 3 h" / "ayer" (en: "now" / "5 min. ago"…) y, a
 * partir de una semana, la fecha corta ("04 oct"). Localizado con `Intl` según el
 * idioma activo — antes estaba escrito a mano y fijado a español.
 */
export function formatRelativeTime(
  iso: string,
  language: string,
  now: number = Date.now(),
): string {
  const diffSec = Math.floor((now - new Date(iso).getTime()) / 1000)
  const rtf = relativeTimeFormat(language, { numeric: 'auto', style: 'short' })
  if (diffSec < 60) return rtf.format(0, 'second')
  if (diffSec < 3600) return rtf.format(-Math.floor(diffSec / 60), 'minute')
  if (diffSec < 86400) return rtf.format(-Math.floor(diffSec / 3600), 'hour')
  if (diffSec < 86400 * 7) return rtf.format(-Math.floor(diffSec / 86400), 'day')
  return dateTimeFormat(language, { day: '2-digit', month: 'short' }).format(new Date(iso))
}
